// extracted by mini-css-extract-plugin
module.exports = {"SidePageContent":"SidePageContent_SidePageContent__GYzgy"};